import React from 'react';
import { useToast, Grid, Heading } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { InputFileDragAndDrop } from 'components';
import { useUploadCampaignCodes } from 'queries/monitoring';
import type { MonitoringUploadResponse } from 'queries/monitoring';

const MAX_FILE_SIZE_MB = 50;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

export const MonitoringUploadFiles = ({
  campaignId,
}: {
  campaignId: number;
}): JSX.Element => {
  const { t } = useTranslation();
  const toast = useToast({
    position: 'bottom',
    duration: 5000,
    isClosable: true,
  });
  const mutationCreateFile = useUploadCampaignCodes();

  const handleUploadComplete = (
    _uploadedCount: number,
    results: MonitoringUploadResponse[],
  ) => {
    const added = results.flatMap(result => result.summary.added);
    const duplicated = results.flatMap(result => result.summary.duplicated);

    toast({
      title: t('success', 'Sukces'),
      description:
        duplicated.length > 0
          ? t('monitoring.codesUploadSummaryWithDuplicates', {
              addedCount: added.length,
              duplicatedCount: duplicated.length,
              defaultValue:
                'Dodano {{addedCount}} kodów, pominięto {{duplicatedCount}} duplikatów',
            })
          : t('monitoring.codesUploadSummary', {
              addedCount: added.length,
              defaultValue: 'Dodano {{addedCount}} kodów',
            }),
      status: 'success',
    });
  };

  const handleUploadError = () => {
    toast({
      title: t('monitoring.fileUploadError', 'Błąd podczas wysyłania plików'),
      status: 'error',
    });
  };

  return (
    <Grid gap={4} key='monitoring-upload-files'>
      <Heading as='h2' fontSize='lg'>
        {t('monitoring.uploadCodesHeader', 'Wgraj kody mierzące')}
      </Heading>
      <InputFileDragAndDrop
        maxFileSize={MAX_FILE_SIZE}
        uploadFile={file =>
          mutationCreateFile.mutateAsync({ campaignId, file })
        }
        onUploadComplete={handleUploadComplete}
        onUploadError={handleUploadError}
      />
    </Grid>
  );
};
